<div class="content">
  @if (isLoadingResolve()) {
  <div class="loading">
    <img src="assets/images/icon.png" />
  </div>
  }

  <router-outlet> </router-outlet>
</div>
